"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = Slider;
exports.RangeSlider = RangeSlider;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _StripesTheme = require("../../StripesTheme.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    width: ", "px;\n    height: ", "px;\n    background-color: ", ";\n    transform: translateX(", "px);\n    position: absolute;\n    z-index: 10;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "px;\n    background-color: ", ";\n    position: absolute;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    height: ", "px;\n    background-color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    width: ", "px;\n    height: ", "px;\n    background-color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: fit-content;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    margin: 0 ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-color: ", ";\n    padding: ", "px 0;\n    display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ParentWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.colorObj.backgroundColor;
}, function (props) {
  return props.spacingObj.padding * 2;
});

var SliderWrapper = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.spacingObj.margin;
});

var SliderBackground = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.spacingObj.backgroundWidth;
}, function (props) {
  return props.spacingObj.backgroundHeight;
}, function (props) {
  return props.colorObj.sliderBackgroundColor;
});

var FilledBackground = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.spacingObj.backgroundHeight;
}, function (props) {
  return props.colorObj.filledBackgroundColor;
});

var SliderHandle = _styledComponents["default"].div(_templateObject5(), function (props) {
  return props.spacingObj.handleDiameter;
}, function (props) {
  return props.spacingObj.handleDiameter;
}, function (props) {
  return props.spacingObj.handleDiameter;
}, function (props) {
  return props.colorObj.filledBackgroundColor;
});

var Marker = _styledComponents["default"].div(_templateObject6(), function (props) {
  return props.spacingObj.markerWidth;
}, function (props) {
  return props.spacingObj.markerHeight;
}, function (props) {
  return props.colorObj.filledBackgroundColor;
}, function (props) {
  return props.left;
});

function getInitialHandlePos(val, spacing) {
  return spacing.backgroundWidth * (val * 0.01) - spacing.handleDiameter / 2;
}

function getMarkers(numMarkers, spacing, colors) {
  var markers = [];
  var markerPositions = []; //first marker

  markers.push( /*#__PURE__*/_react["default"].createElement(Marker, {
    key: "first marker",
    left: 0,
    spacingObj: spacing,
    colorObj: colors
  }));
  markerPositions.push(0);

  if (numMarkers > 2) {
    var spacingGap = spacing.backgroundWidth / (numMarkers - 1);

    for (var i = 1; i <= numMarkers - 2; i++) {
      var pos = spacingGap * i;
      markers.push( /*#__PURE__*/_react["default"].createElement(Marker, {
        key: "marker ".concat(i),
        left: pos,
        spacingObj: spacing,
        colorObj: colors
      }));
      markerPositions.push(pos);
    }
  } //last marker


  var lastPos = spacing.backgroundWidth;
  markers.push( /*#__PURE__*/_react["default"].createElement(Marker, {
    key: "last marker",
    left: spacing.backgroundWidth,
    spacingObj: spacing,
    colorObj: colors
  }));
  markerPositions.push(lastPos);
  return [markers, markerPositions];
}
/**Sliders allow users to make selectoins from a range of values. 
 * Sliders are continuous by default but can be made discrete by giving a value to the 'numMarkers' prop.
 * @example import { Slider } from '@desktop/react';
*/


function Slider(props) {
  var inherit = "slider";
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var colors = context.getColors()[inherit];
  var spacing = context.getSpacing()[inherit];
  var handleRadius = spacing.handleDiameter / 2;
  var initialVal = props.initialVal > 100 ? 100 : props.initialVal < 0 ? 0 : props.initialVal;

  var _useState = (0, _react.useState)(getInitialHandlePos(initialVal, spacing)),
      _useState2 = _slicedToArray(_useState, 2),
      handlePosition = _useState2[0],
      setHandlePosition = _useState2[1];

  var _useState3 = (0, _react.useState)(initialVal),
      _useState4 = _slicedToArray(_useState3, 2),
      fill = _useState4[0],
      setFillVal = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      windowWidth = _useState6[0],
      setWindowWidth = _useState6[1];

  var fillRef = (0, _react.useRef)(initialVal);
  var lowerLimit = (0, _react.useRef)(0);
  var upperLimit = (0, _react.useRef)(0);
  var backgroundRef = (0, _react.useRef)(null);
  var markerPositions = [];
  var markers = [];
  var numMarkers = props.numMarkers === 1 ? 2 : props.numMarkers;

  if (numMarkers > 0) {
    var _getMarkers = getMarkers(numMarkers, spacing, colors);

    var _getMarkers2 = _slicedToArray(_getMarkers, 2);

    markers = _getMarkers2[0];
    markerPositions = _getMarkers2[1];
  }

  function updateWindowWidth() {
    setWindowWidth(window.innerWidth);
  }

  (0, _react.useEffect)(function () {
    if (numMarkers > 0) {
      var newPos = markerPositions[Math.round(handlePosition / segment)] - handleRadius;
      setHandlePosition(newPos);
      setFill(newPos);
    }

    lowerLimit.current = backgroundRef.getBoundingClientRect().left;
    upperLimit.current = backgroundRef.getBoundingClientRect().right;
    window.addEventListener('resize', updateWindowWidth);
    return function () {
      return window.removeEventListener('resize', updateWindowWidth);
    };
  }, []);
  (0, _react.useEffect)(function () {
    lowerLimit.current = backgroundRef.getBoundingClientRect().left;
    upperLimit.current = backgroundRef.getBoundingClientRect().right;
  }, [windowWidth]);

  function setFill(val) {
    var newVal = (val + handleRadius) / spacing.backgroundWidth * 100;
    setFillVal(newVal);
    fillRef.current = newVal;
  }

  function handleMouseDown(event) {
    event.preventDefault();

    if (typeof event.button === "number" && event.button !== 0) {
      return;
    }

    window.addEventListener('mousemove', changeHandlePos);
    window.addEventListener('mouseup', handleMouseUp);
    changeHandlePos(event);
  }

  var segment = spacing.backgroundWidth / (numMarkers - 1);

  function changeHandlePos(_ref) {
    var clientX = _ref.clientX;
    var mousePos = clientX - handleRadius; //mouse calibration

    if (numMarkers > 0) {
      var point = mousePos - lowerLimit.current - handleRadius;
      var newPos = markerPositions[Math.round(point / segment)] - handleRadius;
      setHandlePosition(newPos);
      setFill(newPos);
    } else {
      var _newPos = Math.min(upperLimit.current - handleRadius, Math.max(lowerLimit.current - handleRadius, mousePos)) - lowerLimit.current;

      setHandlePosition(_newPos);
      setFill(_newPos);
    }
  }

  function handleMouseUp(_ref2) {
    var clientX = _ref2.clientX;
    window.removeEventListener('mousemove', changeHandlePos);
    window.removeEventListener('mouseup', handleMouseUp);
    props.onChange(fillRef.current);
  }

  return /*#__PURE__*/_react["default"].createElement(ParentWrapper, {
    spacingObj: spacing,
    colorObj: colors,
    style: props.style
  }, props.leftContent, /*#__PURE__*/_react["default"].createElement(SliderWrapper, {
    spacingObj: spacing,
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/_react["default"].createElement(SliderHandle, {
    style: {
      transform: "translateX(".concat(handlePosition, "px)")
    },
    key: "handle",
    onMouseDown: handleMouseDown,
    spacingObj: spacing,
    colorObj: colors
  }), props.numMarkers > 0 && markers, /*#__PURE__*/_react["default"].createElement(SliderBackground, {
    ref: function ref(passed) {
      return backgroundRef = passed;
    },
    spacingObj: spacing,
    colorObj: colors
  }, /*#__PURE__*/_react["default"].createElement(FilledBackground, {
    style: {
      width: "".concat(fill, "%")
    },
    spacingObj: spacing,
    colorObj: colors
  }))), props.rightContent);
}

Slider.defaultProps = {
  initialVal: 0,
  numMarkers: 0,
  leftContent: [],
  rightContent: [],
  style: {},
  onChange: function onChange() {
    return false;
  }
};
Slider.propTypes = {
  /**The initial value the Slider is set to. If outside the range 0-100 it will be set to the nearest bound. */
  initialVal: _propTypes["default"].number,

  /**The number of value indicators on the Slider. If given 1, it will be increased to 2 by default. */
  numMarkers: _propTypes["default"].number,

  /**The content displayed to the left of the Slider.  */
  leftContent: _propTypes["default"].node,

  /**The content displayed to the right of the Slider.  */
  rightContent: _propTypes["default"].node,

  /**The callback function fired when the handle is released. */
  onChange: _propTypes["default"].func,

  /**Extends the base styling of the Slider element. */
  style: _propTypes["default"].object
};
/**
 * A Range Slider is used to select a lower and upper limit from a range of values.
 * @example import { RangeSlider } '@desktop/react';
 */

function RangeSlider(props) {
  var inherit = "slider";
  var context = (0, _react.useContext)(_StripesTheme.StripesThemeContext);
  var colors = context.getColors()[inherit];
  var spacing = context.getSpacing()[inherit];
  var handleRadius = spacing.handleDiameter / 2;
  var initialValLower = props.initialValLower > 100 ? 100 : props.initialValLower < 0 ? 0 : props.initialValLower > props.initialValUpper ? props.initialValUpper : props.initialValLower;
  var initialValUpper = props.initialValUpper > 100 ? 100 : props.initialValUpper < 0 ? 0 : props.initialValUpper < props.initialValLower ? props.initialValLower : props.initialValUpper === props.initialValLower ? props.initialValUpper + 5 : props.initialValUpper;

  var _useState7 = (0, _react.useState)(getInitialHandlePos(initialValLower, spacing)),
      _useState8 = _slicedToArray(_useState7, 2),
      handlePositionLower = _useState8[0],
      setHandlePositionLower = _useState8[1];

  var _useState9 = (0, _react.useState)(getInitialHandlePos(initialValUpper, spacing)),
      _useState10 = _slicedToArray(_useState9, 2),
      handlePositionUpper = _useState10[0],
      setHandlePositionUpper = _useState10[1];

  var _useState11 = (0, _react.useState)(0),
      _useState12 = _slicedToArray(_useState11, 2),
      windowWidth = _useState12[0],
      setWindowWidth = _useState12[1];

  var handlePositionLowerRef = (0, _react.useRef)(handlePositionLower);
  var handlePositionUpperRef = (0, _react.useRef)(handlePositionUpper);

  var _useState13 = (0, _react.useState)(0),
      _useState14 = _slicedToArray(_useState13, 2),
      fill = _useState14[0],
      setFill = _useState14[1];

  var lowerLimit = (0, _react.useRef)(0);
  var upperLimit = (0, _react.useRef)(0);
  var currentHandle = (0, _react.useRef)('');
  var backgroundRef = (0, _react.useRef)(null);
  var markerPositions = [];
  var markers = [];
  var numMarkers = props.numMarkers === 1 ? 2 : props.numMarkers;

  if (numMarkers > 0) {
    var _getMarkers3 = getMarkers(numMarkers, spacing, colors);

    var _getMarkers4 = _slicedToArray(_getMarkers3, 2);

    markers = _getMarkers4[0];
    markerPositions = _getMarkers4[1];
  }

  function updateWindowWidth() {
    setWindowWidth(window.innerWidth);
  }

  (0, _react.useEffect)(function () {
    if (props.numMarkers > 0) {
      var newPosLower = markerPositions[Math.round(handlePositionLower / segment)] - handleRadius;
      setHandlePositionLower(newPosLower);
      var newPosUpper = markerPositions[Math.round(handlePositionUpper / segment)] - handleRadius;
      setHandlePositionUpper(newPosUpper);
    }

    lowerLimit.current = backgroundRef.getBoundingClientRect().left;
    upperLimit.current = backgroundRef.getBoundingClientRect().right;
    window.addEventListener('resize', updateWindowWidth);
    return function () {
      return window.removeEventListener('resize', updateWindowWidth);
    };
  }, []);
  (0, _react.useEffect)(function () {
    lowerLimit.current = backgroundRef.getBoundingClientRect().left;
    upperLimit.current = backgroundRef.getBoundingClientRect().right;
  }, [windowWidth]);
  var limits = {};
  var segment = spacing.backgroundWidth / (numMarkers - 1);

  function handleMouseDown(event, setHandlePosition) {
    if (typeof event.button === "number" && event.button !== 0) {
      return;
    }

    event.preventDefault();
    limits = {
      lower: currentHandle.current === 'lower' ? lowerLimit.current : handlePositionLowerRef.current + lowerLimit.current + spacing.handleDiameter * 1.5,
      upper: currentHandle.current === 'lower' ? handlePositionUpperRef.current + lowerLimit.current - handleRadius : upperLimit.current
    };
    window.addEventListener('mousemove', changeHandlePos);
    window.addEventListener('mouseup', handleMouseUp);
    window.setHandlePosition = setHandlePosition;
    changeHandlePos(event, setHandlePosition);
  }

  function changeHandlePos(_ref3) {
    var clientX = _ref3.clientX;
    var mousePos = clientX - handleRadius; //mouse calibration

    if (numMarkers > 0) {
      var point = mousePos - lowerLimit.current - handleRadius;
      var newPos = markerPositions[Math.round(point / segment)] - handleRadius;

      if (currentHandle.current === 'lower') {
        if (newPos <= limits.upper - lowerLimit.current) {
          window.setHandlePosition(newPos);
          handlePositionLowerRef.current = newPos;
        }
      } else {
        if (newPos > limits.lower - lowerLimit.current) {
          window.setHandlePosition(newPos);
          handlePositionUpperRef.current = newPos;
        }
      }
    } else {
      var _newPos2 = Math.min(limits.upper - handleRadius, Math.max(limits.lower - handleRadius, mousePos)) - lowerLimit.current;

      window.setHandlePosition(_newPos2);

      if (currentHandle.current === 'lower') {
        handlePositionLowerRef.current = _newPos2;
      } else {
        handlePositionUpperRef.current = _newPos2;
      }
    }
  }

  function pixelToPercentage(val) {
    return val / spacing.backgroundWidth * 100;
  }

  function handleMouseUp(_ref4) {
    var clientX = _ref4.clientX;
    window.removeEventListener('mousemove', changeHandlePos);
    window.removeEventListener('mouseup', handleMouseUp);
    var lowerVal = pixelToPercentage(handlePositionLowerRef.current + handleRadius);
    var upperVal = pixelToPercentage(handlePositionUpperRef.current + handleRadius);
    props.onChange(lowerVal, upperVal);
  }

  function moveLower(event) {
    currentHandle.current = 'lower';
    handleMouseDown(event, setHandlePositionLower);
  }

  function moveUpper(event) {
    currentHandle.current = 'upper';
    handleMouseDown(event, setHandlePositionUpper);
  }

  return /*#__PURE__*/_react["default"].createElement(ParentWrapper, {
    spacingObj: spacing,
    colorObj: colors,
    style: props.style
  }, props.leftContent, /*#__PURE__*/_react["default"].createElement(SliderWrapper, {
    spacingObj: spacing
  }, /*#__PURE__*/_react["default"].createElement(SliderHandle, {
    style: {
      transform: "translateX(".concat(handlePositionLower, "px)")
    },
    key: "lower handle",
    onMouseDown: moveLower,
    spacingObj: spacing,
    colorObj: colors
  }), /*#__PURE__*/_react["default"].createElement(SliderHandle, {
    style: {
      transform: "translateX(".concat(handlePositionUpper, "px)")
    },
    key: "upper handle",
    onMouseDown: moveUpper,
    spacingObj: spacing,
    colorObj: colors
  }), props.numMarkers > 0 && markers, /*#__PURE__*/_react["default"].createElement(SliderBackground, {
    ref: function ref(passed) {
      return backgroundRef = passed;
    },
    spacingObj: spacing,
    colorObj: colors
  }, /*#__PURE__*/_react["default"].createElement(FilledBackground, {
    style: {
      width: "".concat(handlePositionUpper - handlePositionLower, "px"),
      transform: "translateX(".concat(handlePositionLower, "px)")
    },
    spacingObj: spacing,
    colorObj: colors
  }))), props.rightContent);
}

RangeSlider.propTypes = {
  /**The initial position of the lower handle. If this is larger than the value of 'initialValUpper', the values will be swapped. */
  initialValLower: _propTypes["default"].number,

  /**The initial position of the upper handle. */
  initialValUpper: _propTypes["default"].number,

  /**The number of value indicators on the Slider. If given 1, it will be increased to 2 by default. */
  numMarkers: _propTypes["default"].number,

  /**The content displayed to the left of the Slider. */
  leftContent: _propTypes["default"].node,

  /**The content displayed to the right of the Slider. */
  rightContent: _propTypes["default"].node,

  /**The callback function fired when one of the handles is released. */
  onChange: _propTypes["default"].func,

  /**Extends the base styling of the Range Slider element. */
  style: _propTypes["default"].object
};
RangeSlider.defaultProps = {
  initialValLower: 25,
  initialValUpper: 75,
  numMarkers: 0,
  leftContent: [],
  rightContent: [],
  onChange: function onChange() {
    return false;
  },
  style: {}
};